if (!rtAPI) var rtAPI = {};
if (!rtAPI.security) rtAPI.security = {};

//#region Vars

rtAPI.security.pnl = {
    login: 'pnlLogin',
    lostPassword: 'pnlLostPassword',
    lostUsername: 'pnlLostUsername',
    resendAuthEmail: 'pnlResendAuthEmail',
    tFASelect: 'pnl2FASelect',
    tFASelectOptions: 'pnl2FASelectOptions',
    tFACode: 'pnl2FACode',
    tFAMemorableData: 'pnl2FAMemorableData',
    tFAMemorableDataFields: 'pnl2FAMemorableDataFields',
    tFAHardwareKey: 'pnl2FAHardwareKey',
    dialog: 'pnlSecurityDialog_Overlay',
    dialogTitle: 'pnlSecurityDialog_Title',
    dialogFields: 'pnlSecurityDialog_Fields',
    dialogMessages: 'pnlSecurityDialog_Messages',
    dialogButtons: 'pnlSecurityDialog_Buttons',
    logout: 'pnlLogout',
    updatePassword: 'pnlUpdatePassword'
};

rtAPI.security.fd = {
    login: 'fdPWLogin',
    password: 'fdPWPassword',
    loginLost: 'fdPWLoginLost',
    loginLostEmail: 'fdPWLoginLostEmail',
    manageTFA: 'fdManageTFA',
    resendAuthEmail: 'fdResendAuthEmail',
    authenticationMethod: 'fdAuthenticationMethod',
    authenticationCode: 'fdAuthenticationCode',
    oldPassword: 'fdOldPassword',
    newPassword: 'fdNewPassword',
    retypeNewPassword: 'fdRetypeNewPassword'
};

rtAPI.security.errorMessage = {
    login: 'Please enter your login',
    password: 'Please enter your password',
    loginLostEmail: 'Please enter your registered email address',
    loginLost: 'Please enter your login',
    resendAuthEmail: 'Please enter the email address you are trying to authorise',
    authenticationCode: 'Please enter the authentication code from the email or SMS you were sent',
    oldPassword: 'Please enter your current password',
    newPassword: 'Please enter a new password',
    retypeNewPassword: 'Please retype you new password',
    retypeNewPasswordMustMatch: 'Your retyped new password must match your new password',
    weakPassword: 'Your new password does not meet the minimum password strength'
};

rtAPI.security.btn = {
    login: 'btnLogin',
    lostPassword: 'btnLostPassword',
    lostUsername: 'btnLostUsername',
    resendAuthEmail: 'btnResendAuthEmail',
    getPassword: 'btnGetPassword',
    getPasswordCancel: 'btnGetPasswordCancel',
    getUsername: 'btnGetUsername',
    getUsernameCancel: 'btnGetUsernameCancel',
    resendAuthEmailSend: 'btnResendAuthEmailSend',
    resendAuthEmailCancel: 'btnResendAuthEmailCancel',
    tFASelectCancel: 'btn2FASelectCancel',
    tFAAuthenticateCodeSend: 'btnAuthenticateCodeSend',
    tFAAuthenticateCodeCancel: 'btnAuthenticateCodeCancel',
    tFAHardwareKeyRegister: 'btnHardwareKeyRegister',
    tFAHardwareKeyRetry: 'btnHardwareKeyRetry',
    tFAHardwareKeyCancel: 'btnHardwareKeyCancel',
    tFAMemorableDataSend: 'btnMemorableDataSend',
    tFAMemorableDataCancel: 'btnMemorableDataCancel',
    //tFAManageHardwareKeyAdd: 'btn2FAManageHardwareKeyAdd',
    //tFAManageUpdate: 'btn2FAManageUpdate',
    //tFAManageBack: 'btn2FAManageBack',
    //tFAManageClose: 'btn2FAManageClose',
    logout: 'btnLogout',
    updatePassword: 'btnUpdatePassword',
    updatePasswordClose: 'btnUpdatePasswordClose',
    showUpdatePassword: 'btnShowUpdatePassword'
};

rtAPI.security.panelUpdateCallback = null;
rtAPI.security.handle = {};
rtAPI.security.call = {};
rtAPI.security.tFASelectModeTriggered = false;
rtAPI.security.showTFAManagement = false;
rtAPI.security.renderedTFAOptions = '';
rtAPI.security.tFAData = {};
rtAPI.security.samePageLogin = true;
rtAPI.security.enableTFAManagement = true;
rtAPI.security.enableGetUsername = true;
rtAPI.security.enableAccountActivation = true;
rtAPI.security.enableGetPassword = true;
rtAPI.security.fireTFAHardwareKeyLoginWhenSelected = true;
rtAPI.security.dialogAutoClose = false;

//#endregion

//#region Init Login and MFA

rtAPI.security.init = function () {
    if (rtAPI.security.initRun) return;
    rtAPI.security.initRun = true;

    //Login
    rtAPI.initElement('security.pnl', 'login', 'pnl-login', 'pnlSecurity');
    rtAPI.initElement('security.fd', 'login', 'cpc-pw-login-input', null, 'requiredGroupLogin');
    rtAPI.initElement('security.fd', 'password', 'cpc-pw-password-input', null, 'requiredGroupLogin');
    rtAPI.initElement('security.fd', 'manageTFA', 'cpc-manage-tfa-input');
    rtAPI.initElement('security.btn', 'login', 'btn-login', 'button');
    rtAPI.initElement('security.btn', 'lostPassword', 'btn-lost-password');
    rtAPI.initElement('security.btn', 'lostUsername', 'btn-lost-username');
    rtAPI.initElement('security.btn', 'resendAuthEmail', 'btn-resend-auth-email');
    rtAPI.clickElement(this.btn.login, this.handle.login);
    rtAPI.clickElement(this.btn.lostPassword, this.handle.showLostPassword);
    rtAPI.clickElement(this.btn.lostUsername, this.handle.showLostUsername);
    rtAPI.clickElement(this.btn.resendAuthEmail, this.handle.showResendAuthEmail);

    //Lost Password
    if (rtAPI.security.enableGetPassword) {
        rtAPI.initElement('security.pnl', 'lostPassword', 'pnl-lost-password', 'pnlSecurity');
        rtAPI.initElement('security.fd', 'loginLost', 'cpc-lost-password-input', null, 'requiredGroupLostPassword');
        rtAPI.initElement('security.btn', 'getPassword', 'btn-get-password', 'button');
        rtAPI.initElement('security.btn', 'getPasswordCancel', 'btn-get-password-cancel', 'button');
        rtAPI.clickElement(this.btn.getPassword, this.handle.getLostPassword);
        rtAPI.clickElement(this.btn.getPasswordCancel, this.handle.showLoginPanel);
    }

    //Lost Username
    if (rtAPI.security.enableGetUsername) {
        rtAPI.initElement('security.pnl', 'lostUsername', 'pnl-lost-username', 'pnlSecurity');
        rtAPI.initElement('security.fd', 'loginLostEmail', 'cpc-lost-username-input', null, 'requiredGroupLostUsername');
        rtAPI.initElement('security.btn', 'getUsername', 'btn-get-username', 'button');
        rtAPI.initElement('security.btn', 'getUsernameCancel', 'btn-get-username-cancel', 'button');
        rtAPI.clickElement(this.btn.getUsername, this.handle.getLostUsername);
        rtAPI.clickElement(this.btn.getUsernameCancel, this.handle.showLoginPanel);
    }

    //Resend Auth Email Panel
    if (rtAPI.security.enableAccountActivation) {
        rtAPI.initElement('security.pnl', 'resendAuthEmail', 'pnl-resend-auth-email', 'pnlSecurity');
        rtAPI.initElement('security.fd', 'resendAuthEmail', 'cpc-resend-auth-email-input', null, 'requiredGroupResendAuthEmail');
        rtAPI.initElement('security.btn', 'resendAuthEmailSend', 'btn-resend-auth-email-send', 'button');
        rtAPI.initElement('security.btn', 'resendAuthEmailCancel', 'btn-resend-auth-email-cancel', 'button');
        rtAPI.clickElement(this.btn.resendAuthEmailSend, this.handle.resendAuthEmailSend);
        rtAPI.clickElement(this.btn.resendAuthEmailCancel, this.handle.showLoginPanel);
    }

    //2FA Select Panel
    rtAPI.initElement('security.pnl', 'tFASelect', 'pnl-two-factor-authentication-select', 'pnlSecurity');
    rtAPI.initElement('security.pnl', 'tFASelectOptions', 'pnl-two-factor-authentication-select-options');
    rtAPI.initElement('security.btn', 'tFASelectCancel', 'btn-two-factor-authentication-select-cancel', 'button');
    rtAPI.clickElement(this.btn.tFASelectCancel, this.handle.tFAAuthenticateCancel);

    //2FA Code Panel
    rtAPI.initElement('security.pnl', 'tFACode', 'pnl-resend-auth-email', 'pnlSecurity');
    rtAPI.initElement('security.fd', 'authenticationCode', 'cpc-authentication-code-input', null, 'requiredGroupAuthCode');
    rtAPI.initElement('security.btn', 'tFAAuthenticateCodeSend', 'btn-authentication-code-send', 'button');
    rtAPI.initElement('security.btn', 'tFAAuthenticateCodeCancel', 'btn-authentication-method-code-cancel', 'button');
    rtAPI.clickElement(this.btn.tFAAuthenticateCodeSend, this.handle.tFAAuthenticateCodeSend);
    rtAPI.clickElement(this.btn.tFAAuthenticateCodeCancel, this.handle.tFAAuthenticateCancel);

    //2FA Memorable Data Panel
    rtAPI.initElement('security.pnl', 'tFAMemorableData', 'pnl-memorable-data', 'pnlSecurity');
    rtAPI.initElement('security.pnl', 'tFAMemorableDataFields', 'pnl-memorable-data-fields');
    rtAPI.initElement('security.btn', 'tFAMemorableDataSend', 'btn-authentication-code-send', 'button');
    rtAPI.initElement('security.btn', 'tFAMemorableDataCancel', 'btn-authentication-method-code-cancel', 'button');
    rtAPI.clickElement(this.btn.tFAMemorableDataSend, this.handle.tFAMemorableDataSend);
    rtAPI.clickElement(this.btn.tFAMemorableDataCancel, this.handle.tFAAuthenticateCancel);

    //2FA Hardware Key Panel
    rtAPI.initElement('security.pnl', 'tFAHardwareKey', 'pnl-hardware-key', 'pnlSecurity');
    rtAPI.initElement('security.btn', 'tFAHardwareKeyRegister', 'btn-hardware-key-register', 'button');
    rtAPI.initElement('security.btn', 'tFAHardwareKeyRetry', 'btn-hardware-key-retry', 'button');
    rtAPI.initElement('security.btn', 'tFAHardwareKeyCancel', 'btn-hardware-key-cancel', 'button');
    rtAPI.clickElement(this.btn.tFAHardwareKeyRegister, this.handle.tFAHardwareKeyRegister);
    rtAPI.clickElement(this.btn.tFAHardwareKeyRetry, this.handle.tFAHardwareKeyRetry);
    rtAPI.clickElement(this.btn.tFAHardwareKeyCancel, this.handle.tFAAuthenticateCancel);


    //Logged in
    rtAPI.initElement('security.pnl', 'logout', 'pnl-logout', 'pnlSecurity');
    rtAPI.initElement('security.btn', 'logout', 'btn-logout', 'button');
    rtAPI.clickElement(this.btn.logout, this.handle.logout);

    rtAPI.security.initSecurityDialog();
    //rtAPI.security.initUpdatePassword();

    //Update panels
    this.call.getCurrentUser()
        .then(result => this.updatePanels(result))
}

//#endregion

//#region Init Security Dialog

rtAPI.security.initSecurityDialog = function (forceShow, autoClose, message) {
    //if (!rtAPI.security.enableTFAManagement) return

    if (rtAPI.security.initSecurityDialogRun) return;
    rtAPI.security.initSecurityDialogRun = true;
    rtAPI.security.createSecurityDialog();


    rtAPI.initElement('security.pnl', 'dialog', 'pnl-manage', 'rt-overlay-panel pnlSecurity');
    rtAPI.initElement('security.pnl', 'dialogFields', 'pnl-manage-fields', 'rt-overlay-panel-fields');
    rtAPI.initElement('security.pnl', 'dialogTitle', 'pnl-overlay-title', 'rt-overlay-panel-title');
    rtAPI.initElement('security.pnl', 'dialogMessages', 'pnl-overlay-messages', 'rt-overlay-panel-messages');
    rtAPI.initElement('security.pnl', 'dialogButtons', 'pnl-overlay-buttons', 'rt-overlay-panel-buttons');
    //rtAPI.initElement('security.btn', 'tFAManageHardwareKeyAdd', 'btn-manage-hardware-key-add', 'button');
    //rtAPI.initElement('security.btn', 'tFAManageUpdate', 'btn-manage-update', 'button');
    //rtAPI.initElement('security.btn', 'tFAManageBack', 'btn-manage-back', 'button');
    //rtAPI.initElement('security.btn', 'tFAManageClose', 'btn-manage-close', 'button');
    //rtAPI.clickElement(this.btn.tFAManageHardwareKeyAdd, this.handle.tFAManageHardwareKeyAdd);
    //rtAPI.clickElement(this.btn.tFAManageUpdate, this.handle.tFAManageUpdate);
    //rtAPI.clickElement(this.btn.tFAManageBack, this.handle.tFAManageBack);
    //rtAPI.clickElement(this.btn.tFAManageClose, this.handle.tFAManageClose);
    rtAPI.security.showSecurityDialog(forceShow, autoClose, message);

}

rtAPI.security.createSecurityDialog = function () {
    var dialog = document.getElementById('pnlSecurityDialog_Overlay');
    if (dialog) return;
    document.body.extendDOM();
    dialog = document.body.addDiv({ 'id': 'pnlSecurityDialog_Overlay', 'className': 'rt-postback-content-overlay' }, document.body.firstChild);
    //dialog.style.display = 'none';
    //document.insertBefore(dialog);

    var securityDialog = dialog.addDiv({ 'id': 'pnlSecurityDialog' });
    var securityDialogContent = securityDialog.addDiv({ 'className': 'rt-overlay-content' });
    securityDialogContent.addH2(null, null, 'pnlSecurityDialog_Title');
    securityDialogContent.addDiv({ 'id': 'pnlSecurityDialog_Fields' });
    securityDialogContent.addDiv({ 'id': 'pnlSecurityDialog_Messages' });
    securityDialogContent.addDiv({ 'id': 'pnlSecurityDialog_Buttons' });
}

rtAPI.security.showSecurityDialog = function (show, autoClose, message) {
    var cursor = 'inherit';
    if (!show) {
        autoClose = false;
        message = '';
    }
    if (autoClose) cursor = 'pointer';
    rtAPI.security.dialogAutoClose = autoClose;
    rtAPI.security.pnl.dialog.style.cursor = cursor;
    rtAPI.displayElement(rtAPI.security.pnl.dialog, show);

    rtAPI.displayElement(rtAPI.security.pnl.dialogMessages, (rtAPI.isNothing(message)));
    rtAPI.security.pnl.dialogMessages.textContent = message;
}


//#endregion

//#region Update Password

rtAPI.security.initUpdatePassword = function () {
    if (rtAPI.security.initUpdatePasswordRun) return;
    rtAPI.security.initUpdatePasswordRun = true;
    return;
    //rtAPI.initElement('security.pnl', 'updatePassword', 'pnl-update-password', 'pnlSecurity');
    //rtAPI.initElement('security.fd', 'oldPassword', 'cpc-pw-old-password-input', null, 'requiredGroupUpdatePassword');
    //rtAPI.initElement('security.fd', 'newPassword', 'cpc-pw-new-password-input', null, 'requiredGroupUpdatePassword');
    //rtAPI.initElement('security.fd', 'retypeNewPassword', 'cpc-pw-retype-new-password-input', null, 'requiredGroupUpdatePassword');
    //rtAPI.initElement('security.btn', 'updatePassword', 'btn-update-password', 'button');
    //rtAPI.initElement('security.btn', 'updatePasswordClose', 'btn-update-password-close', 'button');
    //rtAPI.initElement('security.btn', 'showUpdatePassword', 'btn-show-update-password', 'button');
    //rtAPI.clickElement(this.btn.updatePassword, this.handle.updatePassword);
    //rtAPI.clickElement(this.btn.updatePasswordClose, this.handle.updatePasswordClose);
    //rtAPI.clickElement(this.btn.showUpdatePassword, this.handle.showUpdatePassword);
    //rtAPI.security.fd.newPassword.addEventListener('input', this.handle.inputPasswordField);

    //rtAPI.security.call.getPasswordScoreInfo()
    //    .then(result => {
    //        var id = rtAPI.security.fd.newPassword.id;
    //        globalThis.pass = {};
    //        eval(`globalThis.pass.displayType_${id} = result.data.passDisplayType;`);
    //        eval(`globalThis.pass.useHelp_${id} = result.data.passUseHelp;`);
    //        eval(`globalThis.pass.showOk_${id} = result.data.passShowOk;`);
    //        eval(`globalThis.pass.standards_${id} = result.data.passStandards;`);
    //        eval(`globalThis.pass.complexities_${id} = result.data.passComplexities;`);
    //        eval(`globalThis.pass.complexityThresholds_${id} = result.data.passComplexityThresholds;`);
    //        eval(`globalThis.pass.mins_${id} = result.data.passMins;`);
    //    })
}

//#endregion

//#region Misc

rtAPI.security.clearFields = function () {

    for (const propertyName in rtAPI.security.fd) {
        var item = rtAPI.security.fd[propertyName];
        if (item == undefined) continue;
        switch (item.type) {
            case 'checkbox':
                item.checked = false;
                break;

            default:// text
                item.value = '';
                break;

        }
    }
}

//#endregion

//#region Buttons

rtAPI.security.bindShowMFMButton = function (btn) {
    rtAPI.clickElement(btn, rtAPI.security.handle.showMFM);
}

rtAPI.security.bindShowMFMButtonById = function (btnId) {
    rtAPI.clickElement(document.getElementById(btnId), rtAPI.security.handle.showMFM);
}

rtAPI.security.bindshowUpdatePasswordButton = function (btn) {
    rtAPI.clickElement(btn, rtAPI.security.handle.showUpdatePassword);
}

rtAPI.security.bindshowUpdatePasswordButtonById = function (btnId) {
    rtAPI.clickElement(document.getElementById(btnId), rtAPI.security.handle.showUpdatePassword);
}

//#endregion

//#region 2FAOption 

rtAPI.security.get2FAOption = function (method) {
    for (const option of rtAPI.security.tFAData.options) {
        if (option.method == method) return option;
    }
    console.error(`Cannot find 2FA method ${method}`);
}

rtAPI.security.get2FAOptionField = function (id) {
    if (rtAPI.security.tFAData.password.id == id) return rtAPI.security.tFAData.password;
    for (const option of rtAPI.security.tFAData.options) {
        for (const field of option.fields) {
            if (field.id == id) return field;
        }
    }
    console.error(`Cannot find 2FA field ${id}`);
}

//#endregion
